import { PrimaryTrade } from './models';
import { TradeCategory } from './models/trade-category';

export class ClientVendorSearchModel {
  constructor(SearchRecord?: ClientVendorSearchModel) {
    if (SearchRecord) {
      Object.assign(this, SearchRecord);
    }
  }

  legalNameOrDba: string | null = null;
  Trades: PrimaryTrade[] = [];
  TradeCategories: TradeCategory[] = [];
  address: {
    id: string | null;
    name: string | null;
    location?: {
      latitude: number;
      longitude: number;
    };
  } = {
    id: null,
    name: null
  };
}
